<template>
  <TermGraph
    :request-status="requestStatus"
    :graph-data="graphData"
    :title="title"
    :item-id="itemId"
    :is-modal="isModal"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import TermGraph from '@/components/cards/models/TermGraph';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';

export default {
  name: 'TopTerms',
  components: {
    TermGraph,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawgraphData: [],
      classifiedPercentage: 0,
    };
  },
  computed: {
    graphData() {
      if (Object.keys(this.rawgraphData).length) {
        return this.rawgraphData;
      }
      return {};
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getWarroomService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getWarroomService({
        itemId: this.itemId,
        servicePath: 'termGraph',
      })
        .then(response => {
          this.rawgraphData = response;
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>

<style scoped lang="scss">
  ::v-deep {
    .network {
      width: 100%;
      height: 100%;
    }

    .vis-network {
      canvas {
        height: 100%;
      }
    }
  }
</style>
